export const SEARCHED_DETAILS='SEARCHED_DETAILS';
export const SELECT_JUMP_SEAT='SELECT_JUMP_SEAT';
export const VERIFY_INTERNATIONAL_DOCUMENT='VERIFY_INTERNATIONAL_DOCUMENT';
export const PRINTER_POPUP_SEARCH_PAGE = 'PRINTER_POPUP_SEARCH_PAGE';
export const INITIAL_BAGGAGE_COUNT = 'INITIAL_BAGGAGE_COUNT';